import React, { useState, useMemo, useEffect } from "react";

import FromToPage from "../../components/FromToPage";
import BanerSlider from "../../components/BanerSlider";
import { getBanerSliders, getBestDealProduct } from "../../store/HomeSlice";
import { useDispatch, useSelector } from "react-redux";

import styles from "./style.module.css";
import CategoryBlock from "./categoryBlock";
import { getBrandPageInfo } from "../../store/MainSlice";
import LoadContent from "../../components/LoadContent";
import { Link } from "react-router-dom";

const flattenProducts = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) {
    const first = data[0];
    if (first?.products && Array.isArray(first.products)) {
      return data.flatMap((g) => g.products ?? []);
    }
    if (typeof first === "object" && first !== null && !first.product && !first.categories && first.products) {
      return data.flatMap((g) => g.products ?? []);
    }
    return data;
  }
  if (typeof data === "object") return Object.values(data).flat();
  return [];
};

const getProductsForCategory = (data, categoryId) => {
  if (!data || !categoryId || Array.isArray(data)) return null;
  if (typeof data !== "object") return null;
  const byId = data[String(categoryId)] ?? data[Number(categoryId)];
  return Array.isArray(byId) ? byId : null;
};

const productMatchesCategory = (prod, cat) => {
  const matchById = (c) => c?.id != null && String(c.id) === String(cat.id);
  const matchBySlug = (c) => c?.slug && cat?.slug && c.slug === cat.slug;
  const matchByName = (c) =>
    (c?.name_hy && cat?.name_hy && c.name_hy === cat.name_hy) ||
    (c?.name_en && cat?.name_en && c.name_en === cat.name_en) ||
    (c?.name_ru && cat?.name_ru && c.name_ru === cat.name_ru);
  const prodCats = prod?.product?.categories ?? prod?.categories ?? [];
  const catsList = Array.isArray(prodCats) ? prodCats : prodCats ? [prodCats] : [];
  const singleCat = prod?.category ?? prod?.product?.category;
  if (singleCat) catsList.push(singleCat);
  const catId = prod?.category_id ?? prod?.product?.category_id;
  if (catId != null && String(catId) === String(cat.id)) return true;
  return catsList.some((c) => matchById(c) || matchBySlug(c) || matchByName(c));
};

const Hisense = () => {
  const { currentLanguage, brand } = useSelector(({ main }) => main);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBanerSliders());
    dispatch(getBestDealProduct());
    dispatch(getBrandPageInfo("hisense"));
  }, [dispatch]);

  const [productData, setProductData] = useState(null);
  const [activeCategory4, setActiveCategory4] = useState(null);

  const rawThirdSlider = brand?.products_third_slider;
  const allProducts = useMemo(
    () => flattenProducts(rawThirdSlider),
    [rawThirdSlider]
  );

  const activeCat = useMemo(() => {
    const cats = brand?.categories4 ?? [];
    if (activeCategory4 != null) return cats.find((c) => String(c.id) === String(activeCategory4));
    return cats[0] ?? null;
  }, [brand?.categories4, activeCategory4]);

  const cardDataRefrigеrators = useMemo(() => {
    if (!activeCat) return allProducts;
    const byCategory = getProductsForCategory(rawThirdSlider, activeCat.id);
    if (Array.isArray(byCategory) && byCategory.length > 0) return byCategory;
    if (!allProducts?.length) return [];
    const filtered = allProducts.filter((prod) => productMatchesCategory(prod, activeCat));
    return filtered.length > 0 ? filtered : allProducts;
  }, [allProducts, activeCat, rawThirdSlider]);

  useEffect(() => {
    if (brand?.categories4?.[0] && activeCategory4 === null) {
      setActiveCategory4(brand.categories4[0].id);
    }
  }, [brand?.categories4, activeCategory4]);

  const handlerSetThirdSliderData = (cat) => {
    setActiveCategory4(cat?.id);
  };

  const handlerFirstTabData = (cat) => {
    setProductData(brand?.photos?.filter((prod) => prod.category_id == cat.id));
  };

  return (
    <div className="wrapper">
      <FromToPage
        pages={[{ label: "hisense", value: "/hisense", active: true }]}
      />
      <BanerSlider
        containerStyle={{ padding: "0", position: "relative" }}
        bannerSliders={brand?.slider1}
        imgStyle={{ maxHeight: "none" }}
      />
      {!Object.keys(brand || {}).length ? (
        <LoadContent containerClassName={styles.LoadContentGeneralBaner} />
      ) : (
        <div className={styles.InfoAboutPage}>
          <element
            dangerouslySetInnerHTML={{
              __html: brand?.info?.["descr2_" + currentLanguage],
            }}></element>
        </div>
      )}
      <p className={styles.title}>
        {brand?.info?.["subtitle1_" + currentLanguage]}
      </p>
      <div className={styles.promotionCategoryBlock}>
        {brand?.categories1?.map((cat) => (
          <div
            key={cat.id}
            className={
              productData?.find((prod) => prod.category_id == cat.id)
                ? styles.categories + " " + styles.categoriesActive
                : styles.categories
            }
            onClick={() => {
              handlerFirstTabData(cat);
            }}>
            <span>{cat["name_" + currentLanguage]}</span>
          </div>
        ))}
      </div>
      <div className={styles.discoverBrands}>
        <div className={styles.discoverBanners}>
          <a
            href={
              productData ? productData?.[0]?.href : brand?.photos?.[4]?.href
            }>
            {!Object.keys(brand || {}).length ? (
              <LoadContent
                containerClassName={styles.LoadContentGeneralBaner}
              />
            ) : productData ? (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  productData[0]?.["image_" + currentLanguage]
                }
                alt={""}
              />
            ) : (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.photos?.[4]?.["image_" + currentLanguage]
                }
                alt={""}
              />
            )}
          </a>
        </div>
        <div className={styles.discoverBanners}>
          <a
            href={
              productData ? productData?.[1]?.href : brand?.photos?.[5]?.href
            }>
            {!Object.keys(brand || {}).length ? (
              <LoadContent
                containerClassName={styles.LoadContentGeneralBaner}
              />
            ) : productData ? (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  productData?.[1]?.["image_" + currentLanguage]
                }
                alt={""}
              />
            ) : (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.photos?.[5]?.["image_" + currentLanguage]
                }
                alt={""}
              />
            )}
          </a>
        </div>
        <div className={styles.discoverBanners}>
          <a
            href={
              productData ? productData?.[2]?.href : brand?.photos?.[6]?.href
            }>
            {!Object.keys(brand || {}).length ? (
              <LoadContent
                containerClassName={styles.LoadContentGeneralBaner}
              />
            ) : productData ? (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  productData?.[2]?.["image_" + currentLanguage]
                }
                alt={""}
              />
            ) : (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.photos?.[6]?.["image_" + currentLanguage]
                }
                alt={""}
              />
            )}
          </a>
        </div>
      </div>
      <a href={brand?.baners.baner_1_href}>
        {!Object.keys(brand || {}).length ? (
          <LoadContent containerClassName={styles.LoadContentGeneralBaner} />
        ) : (
          <img
            src={
              process.env.REACT_APP_STORAGE_URL +
              brand?.baners?.["baner_1_" + currentLanguage]
            }
            alt={""}
          />
        )}
      </a>
      <p className={styles.secondTitle}>
        {brand?.info?.["subtitle2_" + currentLanguage]}
      </p>
      <div className={styles.categoryBlockTitle}>
        <Link
          to={""}
          className={styles.categories + " " + styles.categoriesActive}>
          {brand?.categories2?.[0]["name_" + currentLanguage]}
        </Link>
      </div>

      <CategoryBlock
        myData={brand?.products_first_slider}
        showMoreBtn={true}
        showRecordSelector
        url={`${
          currentLanguage !== "hy" ? "/" + currentLanguage : ""
        }/brand/hisense/category`}
      />
      <p className={styles.secondTitle + " " + styles.smartphonesTitle}>
        {brand?.info?.["subtitle3_" + currentLanguage]}
      </p>
      <div className={styles.categoryBlockTitle}>
        <a className={styles.categories + " " + styles.categoriesActive}>
          {brand?.categories3?.[0]["name_" + currentLanguage]}
        </a>
      </div>
      <CategoryBlock
        myData={brand?.products_second_slider}
        showMoreBtn={true}
        showRecordSelector
        url={`${
          currentLanguage !== "hy" ? "/" + currentLanguage : ""
        }/brand/hisense/category`}
      />

      <div className={styles.bannersBlck}>
        <div className={styles.bcannerContent}>
          <a
            className={styles.banner}
            href={brand?.baners.baner_2_href}>
            <img
              src={
                process.env.REACT_APP_STORAGE_URL +
                brand?.baners?.["baner_2_" + currentLanguage]
              }
              alt={""}
            />
          </a>
          <a
            className={styles.banner}
            href={brand?.baners.baner_3_href}>
            <img
              src={
                process.env.REACT_APP_STORAGE_URL +
                brand?.baners?.["baner_3_" + currentLanguage]
              }
              alt={""}
            />
          </a>
        </div>
        <div className={styles.bcannerContent}>
          <a
            className={styles.banner}
            href={brand?.baners.baner_4_href}>
            <img
              src={
                process.env.REACT_APP_STORAGE_URL +
                brand?.baners?.["baner_4_" + currentLanguage]
              }
              alt={""}
            />
          </a>
          <a
            className={styles.banner}
            href={brand?.baners.baner_5_href}>
            <img
              src={
                process.env.REACT_APP_STORAGE_URL +
                brand?.baners?.["baner_5_" + currentLanguage]
              }
              alt={""}
            />
          </a>
        </div>
      </div>
      <p className={`${styles.title} ${styles.titleWithTopSpacing}`}>
        {brand?.info?.["subtitle4_" + currentLanguage]}
      </p>
      <div className={styles.promotionCategoryBlock}>
        {brand?.categories4?.map((cat) => (
          <button
            type="button"
            key={cat.id}
            className={`${styles.categories} ${activeCategory4 === cat.id || activeCategory4 == cat.id ? styles.categoriesActive : ""}`}
            onClick={() => handlerSetThirdSliderData(cat)}>
            {cat["name_" + currentLanguage]}
          </button>
        ))}
      </div>
      <CategoryBlock
        myData={cardDataRefrigеrators}
        showRecordSelector
        isEmptyState={!!brand && !cardDataRefrigеrators.length}
      />
      <div className={styles.lastInfoBrand}>
        <element
          dangerouslySetInnerHTML={{
            __html: brand?.info?.["descr2_" + currentLanguage],
          }}></element>
      </div>
    </div>
  );
};

export default Hisense;
